export {
  PRIMARY_NAVIGATION_STRIP_LABEL_LIST,
  PRIMARY_CONTROLS_STRIP_CONTROL_EDGE_INSET,
  PRIMARY_CONTROLS_STRIP_CONTROL_SIZE,
  PRIMARY_CONTROLS_STRIP_IOS_TOP_ADJUSTMENT,
  PRIMARY_CONTROLS_STRIP_HEIGHT,
  INITIAL_PRIMARY_NAVIGATION_STRIP_LABEL,
  PRIMARY_NAVIGATION_STRIP_ICON_SIZE,
  PRIMARY_NAVIGATION_STRIP_ICON_TOP_OFFSET,
  PRIMARY_NAVIGATION_STRIP_LABEL_FONT_SIZE,
  PRIMARY_NAVIGATION_STRIP_LABEL_LINE_HEIGHT,
  PRIMARY_NAVIGATION_STRIP_LABEL_TOP_OFFSET,
} from "#nav-chrome";
